import React from 'react';
import { Link } from 'react-router-dom';
import { useZitoneoPreview } from '../../../contexts/ZitoneoContentContext';
import { Icon } from '@iconify/react';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';
import { formatDateTime } from '../../../../../utils/formatDates';
import useTimeZone from '../../../../../customHooks/useTimeZone';
import HotelCategory from './HotelCategory';
import Tooltip from '../../../../../muiComponents/Tooltip';
import routes from '../../../../../utils/commonVariables/routes';

const Hero = () => {
    const { visibleLanguage } = useZitoneoUI();
    const {
        HotelOwner,
        Name,
        Address,
        ServiceCategories,
        ActiveServices,
        LastChange,
        IdHotel,
        IdSupplierHotel,
        Rooms,
        ContractType,
        Category,
        CategoryKey,
    } = useZitoneoPreview();
    const translate = useTranslate(undefined, visibleLanguage?.Code);
    const timeZone = useTimeZone();

    return (
        <section className='zitoneo-web-preview__hero'>
            <div className='web-hero__content'>
                <header className='web-hero__header'>
                    <div className='flex flex-align-center gap-20'>
                        <h5>{HotelOwner}</h5>
                        <span
                            className='web-hero__separator'
                            aria-hidden='true'
                        >
                            ·
                        </span>
                        <Tooltip
                            placement='bottom'
                            title={
                                <Link
                                    to={`${routes.propertyDetail(
                                        IdSupplierHotel
                                    )}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    {translate('edit_in_property_detail')}
                                </Link>
                            }
                        >
                            <span>
                                <HotelCategory
                                    category={Category}
                                    categoryKey={CategoryKey}
                                />
                            </span>
                        </Tooltip>
                    </div>

                    <h1>{Name}</h1>

                    <div className='flex flex-align-baseline gap-5'>
                        <Icon
                            icon='mdi:location-on-outline'
                            className='hero-header__address-icon'
                        />
                        <p>{Address || '----'}</p>
                    </div>
                </header>
                <ul className='web-hero__hotel-hightlights'>
                    <li className='hightlight__container'>
                        <p className='hightlight__title'>zitoneo id</p>
                        <h6 className='hightlight__description'>
                            {IdHotel || '----'}
                        </h6>
                    </li>

                    <li className='hightlight__container'>
                        <p className='hightlight__title'>
                            {translate('rooms')}
                        </p>
                        <h6 className='hightlight__description'>
                            {Rooms || '----'}
                        </h6>
                    </li>
                    <li className='hightlight__container'>
                        <p className='hightlight__title'>
                            {translate('contract')}
                        </p>
                        <h6 className='hightlight__description'>
                            {ContractType.Name || '----'}
                        </h6>
                    </li>
                    <li className='hightlight__container'>
                        <p className='hightlight__title'>
                            {translate('last_updated')}
                        </p>
                        <h6 className='hightlight__description'>
                            {formatDateTime(
                                LastChange,
                                visibleLanguage?.Code,
                                timeZone
                            )}
                        </h6>
                    </li>
                </ul>
            </div>
            <aside className='web-hero__services-highlights'>
                <h3 className='services-highlights__title'>
                    <span className='services-highlights__count'>
                        {ActiveServices}
                    </span>
                    {translate('active_services')}
                </h3>
                <ul className='service-highlight__list'>
                    {ServiceCategories.map(category => (
                        <li
                            className='service-highlight__item'
                            key={category.Id}
                        >
                            <div className='flex gap-20'>
                                <Icon
                                    className='service-highlight__item-icon'
                                    icon={category.Icon}
                                />
                                <h6 className='service-highlight__item-title'>
                                    {category.Name}
                                </h6>
                            </div>
                            <p className='service-highlight__item-count'>
                                {
                                    category.Services.filter(
                                        s =>
                                            String(s.IdServiceCategory) ===
                                            category.Id
                                    ).map(s => s.IdServiceType).length
                                }
                            </p>
                        </li>
                    ))}
                </ul>
                <div className='flex flex-between gap-20 flex-align-baseline'>
                    <p className='services-highlights__label'>
                        {translate('distributed_by')}
                    </p>
                    <p className='services-highlights__value'>Zitoneo</p>
                </div>
            </aside>
        </section>
    );
};

export default Hero;
